// Generated by ReScript, PLEASE EDIT WITH CARE


var Header = {
  login_button_text_mobile: "Login to Book",
  login_button_text_desktop: "Login / Signup to Book",
  ga_login_button_click: "Login Button Click",
  ga_login_modal_close: "Close Login Modal",
  ga_mobile_menu_open: "Hamburger Menu Click"
};

var modal_heading = "Welcome! 👋";

function get_login_agreed_docs(tnc_url, privacy_policy_url) {
  return "By proceeding, you agree to the [terms of services](" + tnc_url + ") and [privacy policy](" + privacy_policy_url + ")";
}

var Login = {
  login_heading: "Log in or Sign up to order!",
  form_placeholder: "Enter Phone Number",
  submit_button: "Continue",
  login_tnc: "By proceeding, you agree to the [terms of services](https://porter.in/terms-of-service) and [privacy policy](https://porter.in/privacy-policy)",
  modal_heading: modal_heading,
  modal_subheading: "Log in or make an account if you're new to Porter!",
  ga_form_submit_event: "Login Mobile Number",
  ga_page_landing: "fe_login_land",
  moe_page_landing_parameter: "fe_login_land_moe",
  ga_tnc_tap: "fe_login_tc_tap",
  ga_login_cta: "fe_login_cta_confirm_tap",
  moe_login_cta_parameter: "fe_login_cta_confirm_tap_moe",
  get_login_agreed_docs: get_login_agreed_docs
};

var OtpValidation = {
  heading: "Verify your account",
  sub_heading: "A one time password (OTP) is sent to",
  change_number: "Change",
  input_placeholder: "Enter OTP",
  submit_button: "Verify",
  resend_otp_text: "Didn't receive the code?",
  resent_otp_countdown_text: "Resend in ",
  ga_change_number: "Change Login Number",
  ga_form_submit_event: "Verify OTP",
  moe_form_submit_event_parameter: "Verify OTP_moe",
  ga_page_landing: "fe_loginotp_land",
  moe_page_landing_parameter: "fe_loginotp_land_moe",
  ga_login_otp_cta: "fe_loginotp_cta_confirm_tap",
  ga_registration: "fe_loginotp_registration",
  ga_registration_failed: "fe_loginotp_reg_check_failed"
};

var SignupRequirement = {
  requirement_heading: "One last step - help us serve you better!",
  requirement_subheading: "What are your requirements?",
  personal_requirement_heading: "Personal delivery services",
  personal_requirement_subheading: "I require goods to be delivered for my personal use",
  spot_personal_requirement_heading: "My Personal Needs",
  spot_personal_requirement_subheading: "Shipping items like tiffins, clothes, documents, etc.",
  business_requirement_heading: "Business delivery services",
  business_requirement_subheading: "I require goods to be delivered to or from my business",
  spot_business_requirement_heading: "My Business' Needs",
  spot_business_requirement_subheading: "Shipping goods like plywood, tiles, electronics, etc.",
  houseshift_requirement_heading: "House Shifting",
  houseshift_requirement_subheading: "I require assistance in packing and moving goods to a new house",
  submit_button: "Confirm",
  ga_form_submit_event: "Frequency Selection",
  ga_page_landing: "fe_loginreq_land"
};

var ResendOtp = {
  resend_title: "Resent OTP via",
  sms_heading: "Text SMS",
  sms_subheading: "Ensure a stable signal",
  whatsapp_heading: "Whatsapp",
  whatsapp_subheading: "Ensure a stable data / WiFi connection",
  resend_button: "Continue",
  resend_otp_disabled: "Didn't receive the code? Resend in ",
  resend_otp_enabled_text: "Didn't receive the code?",
  resend_otp_enabled_button: "Resend",
  resend_otp_attempts_error: "Too many attempts, try again in an hour",
  ga_resend_button: "Resend Button Click ",
  ga_form_submit_event: "Resend OTP Verification",
  ga_sms_resend: "SMS",
  ga_whatsapp_resend: "Whatsapp"
};

var Signup = {
  signup_heading: "Set up your account",
  signup_subheading: "Almost there! Just a few steps to set up your new account",
  form_label_name: "Full Name",
  form_label_email: "Email ID",
  form_name_error: "Invalid Name",
  form_name_error_msg: "Please enter valid name",
  form_name_min_char_error_msg: "Name entered is too short (min 3 char)",
  form_name_max_char_error_msg: "Name entered is too long (max 50 char)",
  form_email_error: "Invalid Email ID",
  submit_button: "Sign Up",
  whatsapp_consent: "Send updates via WhatsApp",
  ga_form_submit_event: "Registration New User",
  ga_page_landing: "fe_loginsignup_land",
  moe_page_landing_parameter: "fe_loginsignup_land_moe",
  ga_signup_cta: "fe_loginsignup_cta_confirm_tap",
  moe_signup_cta_parameter: "fe_loginsignup_cta_confirm_tap_moe",
  ga_whatsapp_consent_true: "fe_login_no_whatsapp_consent",
  ga_whatsapp_consent_false: "fe_login_re_whatsapp_consent"
};

var Profile = {
  default_name: "Profile",
  email_label: "EMAIL ADDRESS",
  mobile_label: "MOBILE",
  logout_button: "Logout",
  ga_page_landing: "fe_loginprofile_land"
};

var LoginV2 = {
  modal_subheading: "Sign in or make an account to complete your order with us."
};

var SignupV2 = {
  mobile_input_placeholder: "Enter Phone Number",
  email_input_placeholder: "Enter Email ID",
  whatsapp_consent: "Recieve updates via WhatsApp",
  submit_button: "Continue"
};

var response_resend_otp_success = "Resent OTP successfully";

var response_signup_success = "Customer Successfully Signed up";

var form_error_invalid_mobile = "Invalid Phone number";

var form_error_empty_number = "Phone number cannot be empty";

var form_invalid_otp = "Invalid OTP";

var form_invalid_otp_greater_than_6 = "OTP cannot be greater than 6 digits";

var form_empty_otp = "Enter a valid OTP";

var form_special_characters = "Please enter a valid name (no numbers or symbols)";

var default_auth_prefill = {
  mobile: undefined,
  name: undefined,
  requirement_type: undefined
};

var track_order = "Track Order";

var track_order_live = "Live";

var login_button = "Login to Book";

export {
  response_resend_otp_success ,
  response_signup_success ,
  form_error_invalid_mobile ,
  form_error_empty_number ,
  form_invalid_otp ,
  form_invalid_otp_greater_than_6 ,
  form_empty_otp ,
  form_special_characters ,
  Header ,
  Login ,
  OtpValidation ,
  SignupRequirement ,
  ResendOtp ,
  Signup ,
  Profile ,
  LoginV2 ,
  SignupV2 ,
  default_auth_prefill ,
  track_order ,
  track_order_live ,
  login_button ,
}
/* No side effect */
